import { createGrpcWebTransport } from '@connectrpc/connect-web'
import { createPromiseClient, type PromiseClient } from '@connectrpc/connect'
import { CustomerService } from '@gen/customer/customer_connect.js'
import { loadConfig } from './config.js'

let cached: PromiseClient<typeof CustomerService> | null = null

export async function getCustomerClient(): Promise<PromiseClient<typeof CustomerService>> {
  if (cached) return cached
  const { apiUrl } = await loadConfig()
  const transport = createGrpcWebTransport({
    baseUrl: apiUrl,
    useBinaryFormat: true,
  })
  cached = createPromiseClient(CustomerService, transport)
  return cached
}
